import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { ActivityIndicator } from '@ui/components/common/micro-interactions';
import './style.scss';
// The pointer lock starts immediately (unchanged double-submit guard); the visual only appears when
// loading takes noticeable time, so fast requests no longer flash a full-screen overlay.
const SHOW_INDICATOR_AFTER_MS = 300;
const ANNOUNCE_AFTER_MS = 1000;
const ANNOUNCEMENT = 'Loading…';
// One shared polite status region for all mounted loaders (the app loader and page loaders can be
// mounted together), so "Loading…" is announced once instead of once per loader.
let mountedLoaders = 0;
let announcer = null;
const getAnnouncer = () => {
    if (!announcer || !announcer.isConnected) {
        announcer = document.createElement('span');
        announcer.className = 'loader-status';
        announcer.setAttribute('role', 'status');
        announcer.setAttribute('aria-live', 'polite');
        document.body.appendChild(announcer);
    }
    return announcer;
};
export const Loader = ({ isLoading }) => {
    const [showIndicator, setShowIndicator] = useState(false);
    useEffect(() => {
        if (!isLoading) {
            setShowIndicator(false);
            return undefined;
        }
        mountedLoaders += 1;
        const region = getAnnouncer();
        const indicatorTimer = window.setTimeout(() => setShowIndicator(true), SHOW_INDICATOR_AFTER_MS);
        const announceTimer = window.setTimeout(() => {
            if (region.textContent !== ANNOUNCEMENT)
                region.textContent = ANNOUNCEMENT;
        }, ANNOUNCE_AFTER_MS);
        return () => {
            window.clearTimeout(indicatorTimer);
            window.clearTimeout(announceTimer);
            mountedLoaders -= 1;
            if (mountedLoaders <= 0) {
                mountedLoaders = 0;
                region.textContent = '';
            }
        };
    }, [isLoading]);
    if (!isLoading)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'loader-lock', "aria-hidden": 'true' }), _jsx("div", { className: `loader-scrim${showIndicator ? ' loader-scrim--visible' : ''}`, "aria-hidden": 'true', children: _jsx("div", { className: 'loader-card', children: _jsx(ActivityIndicator, { label: 'Loading\u2026', size: 'lg' }) }) })] }));
};
